var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",class:{ 'bto-sb-loader': _vm.isLoading },on:{"click":function($event){$event.stopPropagation();return _vm.rebet.apply(null, arguments)}}},[(_vm.isLoading)?_c('i',{staticClass:"bto-sb-spinner-v1"}):_vm._e(),_vm._v(" "+_vm._s(_vm.t("M.Rebet"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }